import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@fikasio/react-ui-components';
import styles from './CollapseToggle.module.css';

interface CollapseToggleProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const CollapseToggle = ({
  isCollapsed,
  onToggle,
}: CollapseToggleProps) => {
  const { t } = useTranslation();
  const label = t(isCollapsed ? 'expand' : 'collapse');

  return (
    <button
      aria-expanded={!isCollapsed}
      aria-label={label}
      className={styles.toggle}
      onClick={event => {
        event.stopPropagation();
        onToggle();
      }}
      onMouseDown={event => {
        event.stopPropagation();
      }}
      title={label}
      type="button"
    >
      <Icon
        name={isCollapsed ? 'caret-right' : 'caret-down'}
        style={{ width: 10 }}
      />
    </button>
  );
};

export default CollapseToggle;
